/**
 * Created by wangshhj on 2018/3/13.
 */
import React, { Component } from 'react';
import {
    Modal,
    Button,
    HotKeys,
    Tooltip,
} from '@platform/base';
import { getMultiLang, microAppUtil } from '@platform/api';

// const sizeToType = {
//     'lg': 'senior',
//     'xlg': 'combine',
//     'max': 'max',
// }

require('./createModal.less');

class Modal2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            json: {},
        };
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json });
            }
        };
        getMultiLang({ moduleId: 'container_toast', callback });
    }

    //TODO: 优化：createModal和show两个api每次执行都是最新的  业务组来保证这两个api传的参数的同步，平台无法保证，
    // 这涉及领域改代码
    UNSAFE_componentWillReceiveProps(nextProps) {
        let { modalData, argusObj } = nextProps;
        let nowData = {};
        for (let attr in modalData) {
            for (let attr1 in argusObj) {
                if (attr === attr1) {
                    if (modalData[attr] && argusObj[attr1]) {
                        nowData[attr] = modalData[attr];
                    } else {
                        if (modalData[attr]) {
                            nowData[attr] = modalData[attr];
                        } else {
                            nowData[attr] = argusObj[attr1];
                        }
                    }
                }
            }
        }
        this.setState({ data: nowData });
    }

    render() {
        let { json } = this.state;
        let {
            id,
            size,
            className,
            maskClassName,
            title,
            content,
            noFooter,
            leftBtnName = json['0005'],
            rightBtnName = json['0006'],
            showCustomBtns,
            customBtns,
            hideRightBtn,
            hideLeftBtn,
            disableRightBtn,
            disableLeftBtn,
            container,
        } = this.state.data;
        let {
            onHide,
            mask,
            indexInfo,
            beSureClick,
            cancelClick,
            show,
            size: propSize,
            hotKeyboard = true,
            onEscapeKeyUp,
            draggable,
            resizable,
            type,
            showMaxButton = false,
            maxButtonClick,
            headerRight,
            headerClassName,
            bodyClassName = '',
            footerClassName,
            addLeftBtn,
            addRightBtn,
            headfieldid,
            confirmCancel, // 关闭自定义
            ...others
        } = this.props;

        let mSize = size || propSize || '';
        let max = mSize === 'max' || type === 'max';

        if (max) {
            className = `${className} simpleModal nc-modal-max`;
        } else {
            className = `${className} simpleModal `;
        }

        return (
            <Modal
                type={max ? 'max' : type}
                fieldid={id}
                visible={show}
                onCancel={onHide.bind(this)}
                size={mSize}
                mask={mask}
                indexInfo={indexInfo}
                className={className}
                maskClassName={maskClassName}
                getPopupContainer={container}
                ref={Modal => (this.Modal = Modal)}
                onEscapeKeyUp={onEscapeKeyUp}
                draggable={draggable}
                resizable={resizable}
                id={id}
                noFooter={noFooter}
                // keyboard={!noFooter ? true : ['esc']}
                keyboard={['esc']}
                {...others}
            >
                <Modal.Header fieldid="header-area" className={headerClassName} closeButton showMaxButton={showMaxButton} headerRight={headerRight} maxButtonClick={maxButtonClick} confirmCancel={confirmCancel}
                // 全屏按钮的回调
                // onMaximize={(max, e) => {
                //     let oldSize = this.state.oldSize || mSize || '';
                //     this.setState({
                //         oldSize: oldSize,
                //         // data: {
                //         //     ...this.state.data,
                //         //     size: max ? 'max' : oldSize,
                //         // },
                //     }, () => {
                //         maxButtonClick && maxButtonClick(max, e || {});
                //     });
                // }}
                >
                    <Modal.Title fieldid={headfieldid || (Array.isArray(title) ? title[0] : title)}>{title}</Modal.Title>
                </Modal.Header>
                {/* resizable为false时 去掉可拖拽icon */}
                <Modal.Body className={bodyClassName}>{content}</Modal.Body>
                {!noFooter ? (
                    <Modal.Footer className={footerClassName}>
                        {!showCustomBtns && hotKeyboard && !noFooter && (
                            <HotKeys
                                keyMap={{
                                    sureBtnHandler:
                                        HotKeys.USUAL_KEYS.MODAL_CONFIRM,
                                    cancelBtnHandler:
                                        HotKeys.USUAL_KEYS.MODAL_CANCEL,
                                }}
                                handlers={{
                                    sureBtnHandler: () => {
                                        // 确定按钮的事件 增加top的判断避免所有弹窗逻辑都被触发 by bbqin
                                        if (this.Modal && this.Modal.isTopModal()) {
                                            console.log(
                                                'createModal  sureBtnHandler 事件回调',
                                                // this.Modal.isTopModal(),
                                            );
                                            beSureClick.bind(this)();
                                        }
                                    },
                                    cancelBtnHandler: () => {
                                        // 取消按钮的事件 增加top的判断避免所有弹窗逻辑都被触发  by bbqin
                                        if (this.Modal && this.Modal.isTopModal()) {
                                            console.log(
                                                'createModal cancelBtnHandler 事件回调',
                                            );
                                            cancelClick.bind(this)();
                                        }
                                    },
                                }}
                                className="simpleModal-hotkeys-wrapper"
                                focused={true}
                                attach={document.body}
                                display="inline"
                            />
                        )}
                        {!showCustomBtns && (typeof addLeftBtn === 'function' ? addLeftBtn() : addLeftBtn)}
                        {!showCustomBtns &&
                            hideLeftBtn === false &&
                            leftBtnName &&
                            (hotKeyboard ?
                                (<Tooltip
                                    placement="top"
                                    inverse
                                    overlay={`${leftBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CONFIRM})`}
                                    trigger={['hover']}
                                    className="model-helper-overlay"
                                >
                                    <Button
                                        onClick={beSureClick.bind(this)}
                                        colors="primary"
                                        tabIndex="0"
                                        fieldid="confirm"
                                        disabled={disableLeftBtn}
                                    >
                                        {leftBtnName}(<span className="text-decoration-underline">Y</span>)
                                    </Button>
                                </Tooltip>
                                ) : (<Button
                                    onClick={beSureClick.bind(this)}
                                    colors="primary"
                                    tabIndex="0"
                                    fieldid="confirm"
                                    disabled={disableLeftBtn}
                                >
                                    {leftBtnName}
                                </Button>))
                        }

                        {!showCustomBtns &&
                            hideRightBtn === false &&
                            rightBtnName &&
                            (hotKeyboard ?
                                (<Tooltip
                                    placement="top"
                                    inverse
                                    overlay={`${rightBtnName}  (${HotKeys.USUAL_KEYS.MODAL_CANCEL})`}
                                    trigger={['hover']}
                                    className="model-helper-overlay"
                                >
                                    <Button
                                        onClick={cancelClick.bind(this)}
                                        // shape="border"
                                        tabIndex="0"
                                        colors="secondary"
                                        fieldid="cancel"
                                        disabled={disableRightBtn}
                                    >
                                        {rightBtnName}(<span className="text-decoration-underline">N</span>)
                                    </Button>
                                </Tooltip>
                                ) : (
                                    <Button
                                        onClick={cancelClick.bind(this)}
                                        // shape="border"
                                        colors="secondary"
                                        tabIndex="0"
                                        fieldid="cancel"
                                        disabled={disableRightBtn}
                                    >
                                        {rightBtnName}
                                    </Button>
                                )
                            )
                        }
                        {!showCustomBtns && (typeof addRightBtn === 'function' ? addRightBtn() : addRightBtn)}
                        {showCustomBtns && customBtns ? customBtns : null}
                    </Modal.Footer>
                ) : null}
            </Modal>
        );
    }
}

export default function createModal(
    id,
    {
        title, //标题
        content, //内容
        beSureBtnClick, //确定按钮事件回调
        cancelBtnClick, //取消按钮事件回调
        closeModalEve, //关闭按钮事件回调
        rightBtnName, //左侧按钮名称
        leftBtnName, //右侧按钮名称
        noFooter = false, //是否需要底部按钮
        // 用tinper的默认
        size, //  模态框大小 sm/lg(senior)/xlg(combine)
        userControl = false, // 点 确定/取消 按钮后，是否自动关闭弹出框
        className = '',
        maskClassName = '',
        zIndex,
        hasBackDrop = true, //显示遮罩层
        closeByClickBackDrop = false, //点击遮罩关闭提示框，true是点击关闭，false是阻止关闭,默认是false --UE让禁用这个功能
        showCustomBtns = false, //允许自定义底部按钮
        customBtns, //自定义按钮
        validateCloseBtn = false, //点击关闭X按钮的校验
        hotKeyboard = true, // 热键的配置项
        hideRightBtn = false, //隐藏底部右边的按钮
        hideLeftBtn = false, //隐藏底部左边的按钮
        disableRightBtn = false, //禁用底部右边的按钮
        disableLeftBtn = false, //禁用底部左边的按钮
        container,
        onEscapeKeyUp,
        draggable = true, //可拖拽移动位置
        resizable = true, //可拖拽变化宽高
        type = '',
        ...others
    } = {},
) {
    let custom = (className.indexOf('junior') !== -1) || (className.indexOf('senior') !== -1) || (className.indexOf('combine') !== -1);
    let mSize = custom ? '' : size || '';
    //根据 2021.11版本模态框要求(刘源)要求: 模态框只支持基础(promptBox) 简单(senior) 复杂(combine) 和最大化(max)四种类型
    // 不允许出现其他类型的弹窗
    //基础类型使用promptbox 其他类型使用 createModal 传type参数：senior/combine/max
    if (!type && custom) {
        type = custom;
    }
    let _runContext = this.getQiankunContext();

    let argusObj = {
        id,
        title,
        content,
        beSureBtnClick,
        cancelBtnClick,
        closeModalEve,
        rightBtnName,
        leftBtnName,
        noFooter,
        size: mSize, //传定制大小的类名的时候，size不配置生效，解决配置拖拽的时候的问题
        userControl,
        className,
        maskClassName,
        zIndex,
        hasBackDrop,
        closeByClickBackDrop,
        showCustomBtns,
        customBtns,
        validateCloseBtn,
        hideRightBtn,
        hideLeftBtn,
        disableRightBtn,
        disableLeftBtn,
        container,
        onEscapeKeyUp,
    };
    // YBP-SCM-BUG-5351
    if (!this.state.modal) {
        return null;
    }
    if (!this.state.modal.hasOwnProperty(id)) {
        this.state.modal[id] = argusObj;
    }
    let modalData = this.state.modal[id] || {};
    if (!modalData.update) {
        modalData.content = content;
        modalData.customBtns = customBtns;
    }
    if (!modalData.updateTitle) {
        modalData.title = title; 
    }
    //关闭模态框
    const close = () => {
        modalData.showModal = false;
        this.setState({ modal: this.state.modal });
    };
    /* 点击关闭按钮 */
    const onHide = () => {
        if (!modalData.validateCloseBtn) {
            close();
        }
        if (typeof modalData.closeModalEve === 'function') {
            // tinper判断如果不是promise会直接关闭模态框
            // console.log(new Promise(modalData.closeModalEve))
            return new Promise(modalData.closeModalEve);
        }
    };

    /* 取消按钮事件 */
    const cancelClick = () => {
        if (!modalData.userControl) {
            close();
        }
        if (typeof modalData.cancelBtnClick === 'function') {
            modalData.cancelBtnClick();
        }
    };

    //确认按钮事件
    const beSureClick = () => {
        if (!modalData.userControl) {
            close();
        }
        if (typeof modalData.beSureBtnClick === 'function') {
            modalData.beSureBtnClick();
        }
    };

    let backdrop;
    if (hasBackDrop) {
        if (closeByClickBackDrop) {
            backdrop = closeByClickBackDrop;
        } else {
            backdrop = 'static';
        }
    } else {
        backdrop = hasBackDrop;
    }
    let finalIndex = modalData.zIndex || zIndex;
    let indexInfo = { id, zIndex: finalIndex };
    return (
        <Modal2
            {...others}
            onHide={onHide}
            mask={backdrop}
            backdrop={backdrop}
            indexInfo={indexInfo}
            beSureClick={beSureClick}
            cancelClick={cancelClick}
            modalData={modalData}
            show={modalData.showModal}
            argusObj={argusObj}
            hotKeyboard={hotKeyboard}
            custom={custom}
            onEscapeKeyUp={onEscapeKeyUp}
            draggable={draggable}
            resizable={resizable}
            size={mSize}
            type={type}
            _runContext={_runContext}
        />
    );
}
